import {Component, Input, OnInit} from '@angular/core';
import {RolesService} from '../../../services/roles.service';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

import {HttpClient} from "@angular/common/http";
import {FaqCategory} from "../../../model/FaqCategory";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    imports: [
    FaIconComponent,
    RouterLink,
    NgbTooltip,
    NgbDropdown,
    RouterLinkActive,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem
],
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input()
  allowedRnProducts: FaqCategory[] = [];

  constructor(public rolesService: RolesService, public http: HttpClient) {
  }

  ngOnInit(): void {
  }
}
